import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Col, Row, Button, Form, FormGroup, Label, Input } from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import Get from "../../Get";

function ClientesCreateProspecto() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_GRUPOS = process.env.REACT_APP_URL_GRUPOS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_USERS = process.env.REACT_APP_URL_USERS;
  const URL_SUCURSALES = process.env.REACT_APP_URL_SUCURSALES;
  const URL_AREAS_CLIENTES = process.env.REACT_APP_URL_AREAS_CLIENTES;
  // const [text, setText] = useState(false);

  const [nombre_comercial, setNombreComercial] = useState("NA");
  const [razon_social, setRazonSocial] = useState("NA");
  const [RFC, setRFC] = useState("NA");
  const [calle, setCalle] = useState("NA");
  const [numero_ext, setNumeroExt] = useState("NA");
  const [numero_int, setNumeroInt] = useState("NA");
  const [delegacion, setDelegacion] = useState("NA");
  const [estado, setEstado] = useState("NA");
  const [pais, setPais] = useState("NA");
  const [cp, setCP] = useState("0");
  const [colonia, setColonia] = useState("NA");
  const [condicionesCotizacion, setCondicionesCotizacion] = useState("NA");
  const [codigo, setCodigo] = useState("NA");
  const [ciudad, setCiudad] = useState("NA");
  const [nombre, setNombre] = useState("NA");
  const [apellido, setApellido] = useState("NA");
  const [telefono, setTelefono] = useState("NA");
  const [email, setEmail] = useState("a@a.a");
  const [grupos, setGrupos] = useState([]);
  const [selectedGrupo, setSelectedGrupo] = useState("645167603974a9001492ff60");
  const [plazo, setPlazo] = useState("0");
  const [colaboradores, setColaboradores] = useState([]);
  // const [selectedColaborador, setSelectedColaborador] = useState("");
  const [selectedContacto, setSelectedContacto] = useState("685c2826828070e9314e15c8");
  const [observaciones, setObservaciones] = useState("NA");
  // const [fecha_visita, setFechaVisita] = useState("");
  const [forma_pago, setFormaPago] = useState("Efectivo");
  const [regFiscal, setRegFiscal] = useState("0");
  const [usoCFDI, setusoCFDI] = useState("S01");
  const [formaPagoSAT, setFormaPagoSAT] = useState("99");
  const [condicionesPagoSAT, setCondicionesPagoSAT] = useState("NA");
  const [metodoPagoSAT, setMetodoPagoSAT] = useState("PPD");
  const [password, setPassword] = useState(
    Math.random().toString(36).substring(7)
  );
  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColaboradores = res.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_GRUPOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allGrupos = res.data;
        setGrupos(allGrupos);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);


const saveClientes = async (event) => {
  event.preventDefault();
  setValidaBoton(false);

  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  try {
    // 1. Crear cliente
    const clienteRes = await axios.post(
      URL_CLIENTES,
      {
        nombre_comercial,
        razon_social: nombre_comercial,
        RFC,
        calle,
        numero_ext,
        numero_int,
        delegacion,
        estado,
        pais,
        cp,
        colonia,
        ciudad,
        telefono,
        email,
        grupos: selectedGrupo,
        contacto: selectedContacto,
        observaciones,
        ultimo_pago: "2000-01-01",
        forma_pago,
        codigo,
        plazo,
        cargos: 0,
        abonos: 0,
        saldo: 0,
        cargosk: 0,
        abonosk: 0,
        saldok: 0,
        usoCFDI,
        regFiscal,
        formaPagoSAT,
        condicionesPagoSAT,
        metodoPagoSAT,
        fiscal: "No",
        condicionesCotizacion,
      },
      { headers }
    );

    const idCliente = clienteRes.data._id;

    // 2. Crear sucursal principal
    await axios.post(
      URL_SUCURSALES,
      {
        calle,
        numero_ext,
        numero_int,
        delegacion,
        estado,
        pais,
        cp,
        colonia,
        ciudad,
        clientes: idCliente,
        alias: "1",
        RFC,
        razon_social,
        is_active: "Si",
        regFiscal,
      },
      { headers }
    );

    // 3. Crear área cliente general
    await axios.post(
      URL_AREAS_CLIENTES,
      {
        name: "General",
        clientes: idCliente,
      },
      { headers }
    );

    // 4. Crear log
    await axios.post(
      URL_LOGS,
      {
        tipo: "Crear Cliente",
        detalle: `${nombre_comercial}`,
        user: user.id,
      },
      { headers }
    );

    Swal.fire("Good job!", "Creado con exito", "success");

    setTimeout(() => {
      window.location.reload();
    }, 1000);
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something went wrong!",
      footer: `${error?.response?.data || error.message}`,
    });
    console.log(error);
    setValidaBoton(true);
  }
};

  return (
    <>
      <Header />
      <br />
      <br />
      {user.clientes_create ? (
        <div className="card container">
          <h3 align="center">Nuevo Prospecto</h3>
          {/* <Get/> */}
          <Form onSubmit={saveClientes}>
            <Row>
             
              <Col md={3}>
                <Label>Nombre Comercial</Label>
                <Input
                  type="text"
                  placeholder="Nombre Comercial"
                  value={nombre_comercial}
                  required
                  onChange={(e) => {
                    setNombreComercial(e.target.value);
                  }}
                />
              </Col>
              {/* <Col md={3}>
                <Label>Razon Social</Label>
                <Input
                  type="text"
                  placeholder="Razon Social"
                  value={razon_social}
                  required
                  onChange={(e) => {
                    setRazonSocial(e.target.value);
                  }}
                />
              </Col> */}
             <Col md={3}>
                <Label>Telefono</Label>
                <Input
                  type="text"
                  placeholder="Telefono"
                  value={telefono}
                  required
                  onChange={(e) => {
                    setTelefono(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Email</Label>
                <Input
                  type="email"
                  placeholder="Email"
                  value={email}
                  required
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
               <Col md={12}>
                <Label>Condiciones Cotizacion</Label>
                <Input
                  type="textarea"
                  placeholder="Condiciones Cotizacion"
                  value={condicionesCotizacion}
                  required
                  onChange={(e) => {
                    setCondicionesCotizacion(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/Clientes"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
        </div>
      ) : undefined}
    </>
  );
}

export default ClientesCreateProspecto;
